import React from 'react';
import Image from './Image';
import Currency from '../images/image-currency.jpg';
import Restaurant from '../images/image-restaurant.jpg';
import Plane from '../images/image-plane.jpg';
import Confetti from '../images/image-confetti.jpg';
import Sentence from './smallComponent/Sentence';
import '../style/third.css';

export default function Third(){
    return(
        <div className="tBody">
            <h1 className="h">Latest Article</h1>
            
            <div id="article">
            <div className="aBody">
               <Image className ="boxImg" src={Currency} />
               <p className="pname">By Guvonchi</p>
               <Sentence className="tSen" header="Receiving money in any currency with no fees" paragraph="lorem ipsum dolor sit amet, con lorem ipsum lorem lorem ipsum dolor sit amet, con lorem ips lorem ipsum dolor sit amet, con lorem ips lorem ipsum dolor sit amet, con lorem ips lorem ipsum dolor sit amet, con lorem ips lorem ipsum dolor sit amet, con lorem ips" />
            </div>

            <div className="aBody">
               <Image className ="boxImg" src={Restaurant} />
               <p className="pname">Made in Lagos</p>
               <Sentence className="tSen" header="Treat yourself without worrying about money" paragraph="lorem ipsum dolor sit amet, con lorem ipsum lorem lorem ipsum dolor sit amet, con lorem ips lorem ipsum dolor sit amet, con lorem ips lorem ipsum dolor sit amet, con lorem ips lorem ipsum dolor sit amet, con lorem ips lorem ipsum dolor sit amet, con lorem ips" />
            </div>
            <div className="aBody">
               <Image className ="boxImg" src={Plane} />
               <p className="pname">Christain Botega</p>
               <Sentence className="tSen" header="Take your Easybank card whereever you go" paragraph="lorem ipsum dolor sit amet, con lorem ipsum lorem lorem ipsum dolor sit amet, con lorem ips lorem ipsum dolor sit amet, con lorem ips lorem ipsum dolor sit amet, con lorem ips lorem ipsum dolor sit amet, con lorem ips lorem ipsum dolor sit amet, con lorem ips" />
            </div>
            <div className="aBody">
               <Image className ="boxImg" src={Confetti} />
               <p className="pname">Louis Vuiton</p>
               <Sentence className="tSen" header="Our invite only Beta account are now live!" paragraph="lorem ipsum dolor sit amet, con lorem ipsum lorem lorem ipsum dolor sit amet, con lorem ips lorem ipsum dolor sit amet, con lorem ips lorem ipsum dolor sit amet, con lorem ips lorem ipsum dolor sit amet, con lorem ips lorem ipsum dolor sit amet, con lorem ips" />
            </div>
            </div>
           
        </div>
    )
}